import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

// The desktop mega menu's top row, kept in the main bundle while the menu
// itself (panels, brand and edit lists) is a lazy chunk (LuxuryHeader). The
// header shows <MegaMenuFallback /> until the chunk arrives: the same links,
// the same size, so the nav row never moves (no layout shift).
// MegaMenu.jsx's MENU must list these items in this order (MegaMenu.test.js).
export const MEGA_MENU_TOP = [
  { id: 'shop', label: { en: 'Shop', ar: 'تسوق' }, path: '/products' },
  { id: 'women', label: { en: 'Women', ar: 'نساء' }, path: '/products?cat=women' },
  { id: 'men', label: { en: 'Men', ar: 'رجال' }, path: '/products?cat=men' },
  { id: 'bags', label: { en: 'Bags', ar: 'حقائب' }, path: '/products?cat=bags' },
  { id: 'jewellery', label: { en: 'Jewellery', ar: 'مجوهرات' }, path: '/products?cat=jewelry' },
  { id: 'fragrance', label: { en: 'Fragrance', ar: 'عطور' }, path: '/products?cat=perfumes' },
  { id: 'sale', label: { en: 'Sale', ar: 'تخفيضات' }, path: '/products?sale=true', highlight: true },
];

export const NAV_CLASS = 'hidden items-center gap-1 lg:flex';

export const topLinkClass = (highlight) => `relative flex min-h-[44px] items-center px-3 text-[15px] font-semibold transition-colors duration-150 ${
  highlight ? 'text-crimson-ink' : 'text-charcoal hover:text-crimson-ink dark:text-white'
}`;

export const topBarClass = (on) => `absolute inset-x-3 bottom-1 h-[3px] rounded-full bg-crimson transition-transform duration-200 ease-luxury motion-reduce:transition-none ${
  on ? 'scale-x-100' : 'scale-x-0'
}`;

export const isCurrent = (item, location) => {
  const [path, query] = item.path.split('?');
  if (location.pathname !== path) return false;
  const want = new URLSearchParams(query || '');
  const have = new URLSearchParams(location.search);
  if (!query) return !have.get('cat') && !have.get('sale');
  return [...want.entries()].every(([k, v]) => have.get(k) === v);
};

/** The top row alone (plain links, no panels) while the menu chunk loads. */
export const MegaMenuFallback = () => {
  const { t } = useLanguage();
  const location = useLocation();
  return (
    <nav className={NAV_CLASS} aria-label={t({ en: 'Main navigation', ar: 'القائمة الرئيسية' })}>
      {MEGA_MENU_TOP.map((item) => {
        const current = isCurrent(item, location);
        return (
          <div key={item.id}>
            <Link to={item.path} aria-current={current ? 'page' : undefined} className={topLinkClass(item.highlight)}>
              {t(item.label)}
              <span aria-hidden="true" className={topBarClass(current)} />
            </Link>
          </div>
        );
      })}
    </nav>
  );
};
